import { useRefrigeratorNotificationStore } from '../../../../../store/refrigeratorNotificationStore';
import { useMySubscriptionsQuery } from '../../../../../utils/hook/react-query/useMySubscriptionsQuery';

/**
 * DELIVERING~ 이후라면 새로운 오더가 생성이 됨.
 * 즉 sequence >=2 이면서, localStorage에 담겨있지 않은 새로운 오더가 보이면 notification 띄우기
 */
const useRefrigeratorNotification = () => {
  const savedOrderIds =
    useRefrigeratorNotificationStore.use.refrigeratorNotification();
  const setRefrigeratorNotification =
    useRefrigeratorNotificationStore.use.setRefrigeratorNotification();
  const { allActiveOrders } = useMySubscriptionsQuery();

  const newOrderIds = allActiveOrders
    .filter(
      (order) => order.sequence >= 2 && !savedOrderIds?.includes(order.id),
    )
    .map((order) => order.id);

  const hasUnreadNotifications = newOrderIds.length > 0;

  const readNotification = () => {
    setRefrigeratorNotification([...(savedOrderIds ?? []), ...newOrderIds]);
  };

  return { hasUnreadNotifications, readNotification };
};

export default useRefrigeratorNotification;
